import React from 'react';
import ReactModal from 'react-modal';

var common={ plotter: undefined, 
             user: undefined, 
             server: undefined,
             month: [],
             data: undefined,
             structure: undefined,
             runningon: '',
             srv: { go: false, well: '', data: {} },
             plotdata: { plotstate: {},alldata: [],origin: [],data: {},d3: {}, datasets: {}, localstate: {} }
             };

function isElectron() // is this an electron standalone version
{
  var userAgent = navigator.userAgent.toLowerCase();
  return userAgent.indexOf(' electron/') > -1;
}

function SaveAsFile(t,f,m) // as it says
{
  var FileSaver = require('file-saver');
  try
  {
    var b = new Blob([t],{type:m});
    FileSaver.saveAs(b, f);
  }
  catch (e)
  {
    global.alertx("problems downloading",true);
  }
}


//
// Direct message system ( note issues in "electron" stand alone version )
//
function alertx(message,qerror)
{

  if ( isElectron() )
  {
    const { dialog } = window.require("electron").remote;
    const options =
    {
      title: 'Message',
      message: message
    };

    if (qerror) options.title = 'Error';

    dialog.showMessageBox(null, options);

  }
  else
  {
    if (qerror) alert("Error:"+message);
    else        alert(message);
  }
}

//
// Shared React components
//
class Header extends React.Component 
{
  render() 
  {
    const title = this.props.title;
    return (
      <>
      {title} 
      </>
    );
  }
}

class Selected extends React.Component 
{
  render() 
  {
    var list = [];
    if ( this.props.sect==='Scenarios' )
    {
      list.push(<td key={0} className="selected" >{"Selected:"}</td>);
      list.push(<td key={1} >&nbsp;</td>);
      var i1=2;
      var i2=10;
      for ( var sect in common.structure.sections )
      {
        if ( sect!=='build' )
        {
          var file = 0; if ( typeof this.props.fileselected[sect]!='undefined' && 
                                    this.props.fileselected[sect]<common.data[sect].length ) file = this.props.fileselected[sect];
          list.push(<td key={i1} className="selected" >{common.data[sect][file].name}</td>);
          list.push(<td key={i2}>&nbsp;</td>);
          i1++;
          i2++;
        }
      }
    }
   
    return (
      <table><tbody><tr>
       {list} 
      </tr></tbody></table>
    );
  }

}

//
// List of "files" available i.e. list of wellgeo/properties/actions/build
//
class File extends React.Component 
{
  // eslint-disable-next-line
  constructor(props) 
  {
    super(props)
  }
  render() 
  {
    const files = this.props.files;
    const listopts=files.map((string) => <option key={string} value={string}>{string}</option> );

    var selected=[];

    if ( typeof this.props.multiple!=='undefined' ) 
    {
      for ( var i=0; i<this.props.multiple.length; i++ )
      {
        selected.push(files[this.props.multiple[i]]);
      }
    }
    else
    {
      selected = [files[this.props.selected]];
    }

    return (
      <div className="file">
        <select name="rorig" value={selected} multiple={true} onChange={(e) => this.props.onChange(e) } >
         {listopts}
        </select>
      </div>
    );
  }
}

// 
// Button to get an external "files"
//
class Getfile extends React.Component 
{
  // eslint-disable-next-line
  constructor(props) 
  {
    super(props)
  }
  render() 
  {
    const add = 'import '+this.props.name;
    if ( this.props.name==='model' )
    {
      return ( <div style={{ width: '145px' }} ></div> );
    }
    else 
    {
      return ( <button style={{ width: '145px' }} onClick={(i) => this.props.onClick(i)} >{add}</button> );
    }
  }
}

//
// Display lists of jobs queued and run
//
class Jobs extends React.Component 
{
  // eslint-disable-next-line
  constructor(props) 
  {
    super(props);
    this.state={ showStatus: false, status: [], showqueue: false, qrpt: '' };
  }

  render()
  {
    var qmodal = this.props.getmodel>0;
    var qsrv   = this.props.getmodel===2;

    var title = 'Job Status'; if ( qsrv ) title = 'SRV status';

    var listjobs   = this.props.jobs.map((v,index) => this.renderjobs(v,index,this.props.jobs.length) );
    if ( listjobs.length===0 && qmodal && !this.qstatus ) return <div> Check server status </div>;
    if ( listjobs.length===0                            ) return <div> No Jobs Scheduled</div>;

    var headings = <thead><tr><th>Job</th><th>Name</th><th>Model</th><th>Type</th><th>Complete</th><th>Summary</th><th>Grid Output</th><th>MR output</th><th>Date</th></tr></thead>;
    if ( qsrv ) headings = <thead><tr><th>Job</th><th>Name</th><th>Type</th><th>Complete</th><th>SRV(@frac)</th><th>SRV(@prod)</th><th>Date</th></tr></thead>;

    var liststatus = this.state.status.map((v,index) => this.renderstatus(v,index) );

    var download = '';
    var alllink = common.server+'/'+common.user+'/all.tar.gz';
    var allname = 'all.tar.gz';
    for ( var ijob=0; ijob<this.props.jobs.length; ijob++ )
    {
      if ( this.props.jobs[ijob].name==='downloadall' )
      {
        var alldone = ''; if ( this.props.jobs[ijob].completed ) alldone = 'adddel';
        var date = this.props.jobs[ijob].day+'-'+common.months[this.props.jobs[ijob].mon]+'-'+this.props.jobs[ijob].year;
        download= <><td>&nbsp;</td><td>Download all:</td><td><span className={alldone} onClick={() => this.getBinary(alllink,allname)} >{allname}</span></td><td>from:{date}</td></>;
      }
    }

    return (
        <div className='summary'> 
           <table><tbody><tr><td><table><tbody><tr><td><u>{title}</u></td><td>{download}</td></tr></tbody></table></td></tr>
              <tr><td><div className='jobtable'><table>
                {headings}<tbody>
                {listjobs}
              </tbody></table></div></td></tr>
            </tbody></table>

      <ReactModal isOpen={this.state.showStatus} appElement={document.getElementById('root')}  className="Status"  >
        <div className="Statusbody" >
          <table><tbody><tr><td><b>Run status</b></td><td><span onClick={() => this.endstatus()} >&times;</span></td></tr>
              {liststatus}
                  <tr><td><button onClick={() => this.endstatus() } style={{ width: '80px' }} >ok</button></td>
                  </tr>
         </tbody></table>
      </div>
      </ReactModal>

      <ReactModal isOpen={this.state.showqueue} appElement={document.getElementById('root')}  className="qstatus"  >
        <div className="Statusbody" >
          <table><tbody><tr><td><b>Queue status</b></td><td><span onClick={() => this.endqstatus()} >&times;</span></td></tr>
                  <tr><td>&nbsp;</td></tr>
                  <tr><td>{this.state.qrpt}</td></tr>
                  <tr><td>&nbsp;</td></tr>
                  <tr><td><button onClick={() => this.endqstatus() } style={{ width: '80px' }} >ok</button></td>
                  </tr>
         </tbody></table>
      </div>
      </ReactModal>

                </div>
      );
  }

  renderjobs(v,index,n)
  {
    var qsrv = this.props.getmodel===2;

    var complete='running'; if ( v.completed ) complete='finished'; if ( v.queued ) complete=<span className={'adddel'} onClick={() => this.queuestatus(v.name,v.queue,n-index-1)} >{'queued'} </span>;
    var streport='status';  if ( v.completed ) streport='finished'; if ( v.queued ) streport='';

    var linkname = ''; if ( v.completed ) linkname = 'adddel'; if ( v.completed && v.type==='mr' ) linkname = 'mrlink';

    var lower = false;
    for ( var i=0; i<v.name.length; i++ )
    {
      var c = v.name.substring(i,1);
      if ( isNaN(c) )
      {
        if ( c===c.toLowerCase() ) { lower = true; break; }
      }
    }

    var jsname   = v.name+'.js';
    var jsaname  = v.name+'_se-sone_amalgamate.js'; if ( !lower ) jsaname  = v.name+'_SE-SONE_amalgamate.js';
    var srvname1 = v.name+'_1.srv';
    var srvname2 = v.name+'_2.srv';
    var outname  = v.name+'.tar.gz';
    var outaname = v.name+'_se-sone_output.js';
    var outdname = v.name+'_output.js';
    var prtname  = v.name+'.PRT';
    var qlower = false;
    for ( var i=0; i<v.name.length; i++ )
    {
      var character = v.name.charAt(i);
      if ( character===character.toLowerCase() && character!==character.toUpperCase() ) qlower=true;
    }
    if ( qlower ) prtname = v.name+'.prt';

    var link     = common.server+'/'+common.user+'/'+jsname;  if ( v.type==='mr' ) link = common.server+'/'+common.user+'/'+jsaname;
    var srvlink1 = common.server+'/'+common.user+'/'+srvname1;
    var srvlink2 = common.server+'/'+common.user+'/'+srvname2;
    var outlink  = common.server+'/'+common.user+'/'+outname;
    var outalink = common.server+'/'+common.user+'/'+outaname;
    var prtlink  = common.server+'/'+common.user+'/'+prtname;
    var date = v.day+'-'+common.months[v.mon]+'-'+v.year;

    var model='';
    if ( typeof v.meta!=='undefined' ) model = v.meta.build.name;

    if ( qsrv)
    {
      return (<tr key={index}><td>{index}</td><td>{v.name}</td><td>{model}</td><td>{v.type}</td><td>{complete}</td>
                    <td><span className={linkname} onClick={() => this.getSummary(srvlink1,srvname1,index,0)} >{srvname1} </span></td>
                    <td><span className={linkname} onClick={() => this.getSummary(srvlink2,srvname2,index,0)} >{srvname2} </span></td>
                    <td>{date}</td></tr>);
    }
    else if ( v.name==='downloadall' ) return (<tr key={index}></tr>);
    else if ( v.type==='mr' )
    {
      return (<tr key={index}><td>{index}</td><td>{v.name}</td><td>{model}</td><td>{v.type}</td><td>{complete}</td>
                    <td><span className={linkname} onClick={() => this.getSummary(link,jsname,index,1)} >{jsname} </span></td>
                    <td></td>
                    <td><span className={linkname} onClick={() => this.getSummary(outalink,outdname,index,2)} >{outdname} </span></td>
                    <td>{date}</td>
                    <td><span className={'adddel'} onClick={() => this.getPrint(prtlink,v.completed)} >{streport} </span></td></tr>);
    }
    else
    {
      return (<tr key={index}><td>{index}</td><td>{v.name}</td><td>{model}</td><td>{v.type}</td><td>{complete}</td>
                    <td><span className={linkname} onClick={() => this.getSummary(link,jsname,index,0)} >{jsname} </span></td>
                    <td><span className={linkname} onClick={() => this.getBinary(outlink,outname)} >{outname} </span></td>
                    <td></td>
                    <td>{date}</td>
                    <td><span className={'adddel'} onClick={() => this.getPrint(prtlink,v.completed)} >{streport} </span></td></tr>);
    }
  }

  renderstatus(v,index)
  {
    return (<tr key={index}><td>{v}</td><td>{v.type}</td></tr>);
  }

  getSummary(file,name,index,type)
  {
    if ( this.props.getmodel===1 ) // Summary file to memory
    {
      fetch(file)
      .then(res => res.text())
      .then( (result) => { this.props.loadsummary(result,type);},
             (error) => { alertx(" error "+error); }
           )
    }
    else if ( this.props.getmodel===2 ) // SRV
    {
      fetch(file)
      .then(res => res.text())
      .then( (result) => { this.props.loadsummary(result,index);},
             (error) => { alertx(" error "+error); }
           )
    }
    else // Summary to disk
    {
      fetch(file)
      .then(res => res.text())
      .then( (result) => { this.savefile(result,name);},
             (error) => { alertx(" error "+error); }
           )
    }
  }

  getBinary(file,name)
  {
    fetch(file)
    .then(res => res.blob())
    .then( (result) => { this.savefile(result,name);},
            (error) => { alertx(" error "+error); }
          )
  }

  savefile(data,name)
  {
    SaveAsFile(data,name,"");
  }

  getPrint(file,complete)
  {
    fetch(file)
    .then(res => res.text())
    .then( (result) => { this.status(result,complete);},
            (error) => { alertx(" error "+error); }
          )
  }

  status(print,complete)
  {
    var errors = [];
    var times  = [];
    var array = print.split("\n");
    for ( var i=0; i<array.length; i++ )
    {
      if ( array[i].search("Time:")>0  ) times.push(array[i]);
      if ( array[i].search("Error:")>0 ) errors.push(array[i]);
      if ( array[i].search("Case")>0 && array[i].search("#")>0 ) times.push(array[i]);
      if ( array[i].search("tasks processed")>0 && !complete   ) times.push(array[i]);
    }

    var newstate = Object.assign(this.state);
    newstate.showStatus = true; 
    newstate.status=[];
    for ( i=Math.max(0,errors.length-5); i<errors.length; i++ )
    {
      newstate.status.push(errors[i]);
    }
    if ( errors.length>0 ) newstate.status.push('--------------------------------------------'); 
    newstate.status.push(' ... '); 
    for ( i=Math.max(0,times.length-5); i<times.length; i++ )
    {
      newstate.status.push(times[i]);
    }
    this.setState(newstate);
  }

  endstatus()
  {
    var newstate = Object.assign(this.state);
    newstate.showStatus = false; 
    this.setState(newstate);
  }

  queuestatus(jobname,queue,index)
  {
    fetch(common.server+'/queues.json')
    .then(res => res.json())
    .then( (result) => { this.rptqueues(result,jobname,queue,index);},
            (error) => { alertx(" error "+error); }
          )
  }

  rptqueues(queues,jobname,queue,jobnum)
  {
    var qname = queues[queue].name;
    var position = -1;
    for ( var i=0; i<queues[queue].queue.length; i++ )
    {
      if ( queues[queue].queue[i].job===jobnum )
      {
        position = i;
        break;
      } 
    }
    position += 1;
    var newstate = Object.assign(this.state);
    newstate.showqueue = true;
    newstate.qrpt = 'Job: '+jobname+' Queue: '+qname+' running '+queues[queue].limit+' concurrently - Position in queue: '+position;
    this.setState(newstate);    
  }

  endqstatus()
  {
    var newstate = Object.assign(this.state);
    newstate.showqueue = false; 
    this.setState(newstate);
  }
}

export { alertx, SaveAsFile, Header, Selected, File, Getfile, Jobs, common };
